import styled from 'styled-components';
import { trackClick } from '../../services/adService';

const BannerWrapper = styled.div`
  position: relative;
  width: 100%;
  margin: 0 auto;
  border-radius: ${props => props.theme.borderRadius.lg};
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: ${props => props.theme.shadows.lg};
  }
`;

const BannerLink = styled.a`
  display: block;
  width: 100%;
  text-decoration: none;
  color: inherit;
`;

const BannerImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
`;

const BannerContent = styled.div`
  padding: 1rem;
  background: ${props => props.theme.colors.muted};
  text-align: center;
  
  @media (min-width: 768px) {
    padding: 1.25rem;
  }
`;

const BannerTitle = styled.h3`
  font-size: 1rem;
  font-weight: ${props => props.theme.typography.fontWeights.semibold};
  margin-bottom: 0.5rem;
  color: ${props => props.theme.colors.foreground};
  
  @media (min-width: 768px) {
    font-size: 1.125rem;
  }
`;

const BannerDescription = styled.p`
  font-size: 0.875rem;
  color: ${props => props.theme.colors.mutedForeground};
  margin-bottom: 0.75rem;
  
  @media (min-width: 768px) {
    font-size: 0.9375rem;
  }
`;

const BannerCTA = styled.span`
  display: inline-block;
  padding: 0.5rem 1rem;
  background: ${props => props.theme.colors.foreground};
  color: ${props => props.theme.colors.background};
  border-radius: ${props => props.theme.borderRadius.md};
  font-size: 0.875rem;
  font-weight: 500;
  transition: opacity 0.2s;
  
  &:hover {
    opacity: 0.9;
  }
`;

const BannerAd = ({ ad, onClick }) => {
  const handleClick = (e) => {
    e.preventDefault();
    if (onClick) {
      onClick();
    } else {
      trackClick(ad._id);
      window.open(ad.clickUrl, '_blank', 'noopener,noreferrer');
    }
  };

  const imageUrl = ad.imageUrl || (ad.translations && ad.translations.imageUrl);
  const title = ad.title || '';
  const description = ad.description || '';
  const ctaText = ad.ctaText || 'Learn More';

  return (
    <BannerWrapper data-ad-id={ad._id}>
      <BannerLink
        href={ad.clickUrl}
        onClick={handleClick}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={title || 'Advertisement'}
      >
        {imageUrl ? (
          <BannerImage src={imageUrl} alt={title || 'Advertisement'} />
        ) : null}
        {(title || description || ctaText) && (
          <BannerContent>
            {title && <BannerTitle>{title}</BannerTitle>}
            {description && <BannerDescription>{description}</BannerDescription>}
            {ctaText && <BannerCTA>{ctaText}</BannerCTA>}
          </BannerContent>
        )}
      </BannerLink>
    </BannerWrapper>
  );
};

export default BannerAd;



